var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Admin'
      }],
      "title": "All Admin"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg"
  }, [_c('div', {
    staticClass: "relative w-2/6"
  }, [_c('SearchOutline', {
    attrs: {
      "className": "text-xl absolute top-1/2 left-3 transform -translate-y-1/2"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchTerm,
      expression: "searchTerm"
    }],
    staticClass: "p-2.5 pl-5 w-full text-sm border rounded-md bg-gray-50",
    attrs: {
      "type": "search",
      "placeholder": "Search Email, Publisher"
    },
    domProps: {
      "value": _vm.searchTerm
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      },
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value;
      }, _vm.onSearch]
    }
  })], 1), _c('div', {
    staticClass: "relative flex justify-end w-3/4"
  }, [_c('Button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "default",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/user-admin/create');
      }
    },
    scopedSlots: _vm._u([{
      key: "iconBefore",
      fn: function () {
        return [_c('i', {
          staticClass: "fa fa-plus"
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" Add New ")]), _c('div', {
    ref: "filterContainer",
    staticClass: "relative"
  }, [_c('Button', {
    staticClass: "relative",
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": function ($event) {
        _vm.showFilterModal = !_vm.showFilterModal;
      }
    },
    scopedSlots: _vm._u([{
      key: "iconBefore",
      fn: function () {
        return [_c('FilterFilled', {
          attrs: {
            "className": "h-3 w-3 text-gray-800"
          }
        })];
      },
      proxy: true
    }, {
      key: "iconAfter",
      fn: function () {
        return [_c('ChevronDownFilled', {
          attrs: {
            "className": "h-3 w-3 text-gray-800"
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" Filter "), _vm.activeFilterCount > 0 ? _c('span', {
    staticClass: "absolute flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full -top-2 -right-2"
  }, [_vm._v(" " + _vm._s(_vm.activeFilterCount) + " ")]) : _vm._e()]), _c('AdminFilterModal', {
    attrs: {
      "visible": _vm.showFilterModal,
      "initial-filters": _vm.appliedFilters
    },
    on: {
      "apply-filter": _vm.handleApplyFilter,
      "reset-filter": _vm.handleResetFilter,
      "update:visible": function ($event) {
        _vm.showFilterModal = false;
      }
    }
  })], 1)], 1)])]), _c('Table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "data": _vm.admins,
      "rowKey": _vm.tableRowKeys,
      "currentPage": _vm.currentPage,
      "perPage": _vm.perPage,
      "isLoading": _vm.isLoading,
      "className": "mb-2"
    },
    on: {
      "sort": _vm.handleTableSort
    },
    scopedSlots: _vm._u([{
      key: "email",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('div', {
          staticClass: "lowercase"
        }, [_vm._v(" " + _vm._s(value || '-') + " ")])];
      }
    }, {
      key: "group",
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('div', [value === 'ebook' ? _c('Label', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(" Ebook ")]) : _vm._e(), value === 'publisher' ? _c('Label', {
          attrs: {
            "variant": "yellow"
          }
        }, [_vm._v(" Publisher ")]) : _vm._e(), value === 'publisher_group' ? _c('Label', {
          attrs: {
            "variant": "orange"
          }
        }, [_vm._v(" Publisher Group ")]) : _vm._e()], 1)];
      }
    }, {
      key: "status",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [_c('div', [_c('Label', {
          attrs: {
            "variant": row !== null && row !== void 0 && row.is_active ? 'green' : 'gray'
          }
        }, [_vm._v(" " + _vm._s(row !== null && row !== void 0 && row.is_active ? 'Active' : 'Inactive') + " ")])], 1)];
      }
    }, {
      key: "createdAt",
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatTime(value)) + " ")])];
      }
    }, {
      key: "updatedAt",
      fn: function (_ref5) {
        var value = _ref5.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatTime(value)) + " ")])];
      }
    }, {
      key: "actions",
      fn: function (_ref6) {
        var row = _ref6.row;
        return [_c('t-dropdown', {
          staticClass: "relative",
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function (_ref7) {
              var mousedownHandler = _ref7.mousedownHandler,
                focusHandler = _ref7.focusHandler,
                blurHandler = _ref7.blurHandler,
                keydownHandler = _ref7.keydownHandler,
                isShown = _ref7.isShown;
              return _c('div', {
                class: {
                  'cursor-not-allowed opacity-50 pointer-events-none': _vm.userData.role_id === 14 && row.role_id === 1
                }
              }, [_c('button', {
                staticClass: "cursor-pointer focus:outline-none",
                class: {
                  ' text-gray-500 ': isShown
                },
                attrs: {
                  "id": "user-menu",
                  "aria-label": "User menu",
                  "aria-haspopup": "true"
                },
                on: {
                  "focus": function ($event) {
                    $event.stopPropagation();
                    return focusHandler.apply(null, arguments);
                  },
                  "blur": function ($event) {
                    $event.stopPropagation();
                    return blurHandler.apply(null, arguments);
                  },
                  "keydown": function ($event) {
                    $event.stopPropagation();
                    return keydownHandler.apply(null, arguments);
                  },
                  "click": function ($event) {
                    $event.stopPropagation();
                    return mousedownHandler.apply(null, arguments);
                  }
                }
              }, [_c('i', {
                staticClass: "fa-solid fa-ellipsis"
              })])]);
            }
          }], null, true)
        }, [_c('div', {
          staticClass: "z-50 flex flex-col flex-grow-0 p-1"
        }, [_c('router-link', {
          staticClass: "flex items-center px-3 py-2 text-sm font-normal text-gray-700 no-underline transition-colors duration-150 rounded-lg hover:bg-gray-50",
          attrs: {
            "to": ("/user-admin/edit/" + (row.id))
          }
        }, [_c('EditFilled', {
          staticClass: "w-4 h-4 mr-2"
        }), _vm._v(" Edit Admin ")], 1), _c('router-link', {
          staticClass: "flex items-center px-3 py-2 text-sm font-normal text-gray-700 no-underline transition-colors duration-150 rounded-lg hover:bg-gray-50",
          attrs: {
            "to": ("/user-admin/display/" + (row.id))
          }
        }, [_c('EyeFilled', {
          staticClass: "w-4 h-4 mr-2"
        }), _vm._v(" View Admin ")], 1)], 1)])];
      }
    }])
  }), Number(_vm.totalRows) ? _c('div', {
    staticClass: "flex justify-between pt-4 pl-3 pr-3 mt-1 mb-2 bg-white border-t border-gray-100"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(Number(_vm.totalRows) >= _vm.perPage ? _vm.perPage : Number(_vm.totalRows)) + " "), _c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "disabled": _vm.isLoading,
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }